<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
				<FormItem label="优惠券备注" prop="remark" class="sj">
					<Input v-model="formValidate.remark" placeholder="请输入备注" maxlength="32"></Input>
				</FormItem>
				<FormItem label="兑换码" prop="redeemCode" class="sj">
					<Input v-model="formValidate.redeemCode" placeholder="请输入兑换码" maxlength="10"></Input>
				</FormItem>
				<FormItem label="领券开始时间" prop="receiveBeginTime" class="sj"  >
					<DatePicker v-model="formValidate.receiveBeginTime"  :editable="false" type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker>
				</FormItem>
				<FormItem label="使用开始时间" prop="beginTime" class="sj"  >
					<DatePicker v-model="formValidate.beginTime"  :editable="false" type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker>
				</FormItem>
				<FormItem label="使用结束时间" prop="overTime" class="sj"  >
					<DatePicker v-model="formValidate.overTime"  :editable="false" type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker>
				</FormItem>
				<FormItem label="总金额" prop="minMoney" class="sj">
					<Input v-model="formValidate.minMoney" placeholder="请输入总金额" type="number" disabled ></Input>
				</FormItem>
				<FormItem label="满减金额" prop="reduceMoney" class="sj">
					<Input v-model="formValidate.reduceMoney" placeholder="请输入满减金额" disabled ></Input>
				</FormItem>
				
				<FormItem label="状态" prop="isUse" class="sj">
					<Select v-model="formValidate.isUse" placeholder="请选择状态">
						<Option value="true">启用</Option>
						<Option value="false">停用</Option>
					</Select>
				</FormItem>
				
				<FormItem label="领取方式" prop="method" class="sj">
					<Select v-model="formValidate.method" placeholder="请选择领取方式">
						<Option value="sm">扫码/兑换码领取</Option>
						<Option value="list">小程序内领取</Option>
					</Select>
				</FormItem>
				
				<FormItem label="使用范围" prop="scope" class="sj">
					<Select v-model="formValidate.scope" placeholder="请选择使用范围">
						<Option value="all">当前所有设备</Option>
						<Option value="part">指定设备</Option>
					</Select>
				</FormItem>
				<FormItem label="类型" prop="couponType" class="sj"  >
					<Select v-model="formValidate.couponType" placeholder="请选择优惠券类型" disabled>
						<Option value="MJQ">满减券</Option>
						<Option value="PLQ">品类券</Option>
						<Option value="DPJ">单品券</Option>
					</Select>
				</FormItem>
				
				<FormItem label="可领取数量" prop="maxNumber" class="sj">
					<Input v-model="formValidate.maxNumber" placeholder="请输入数量" type="number" ></Input>
				</FormItem>
				<FormItem label="已领取数量" prop="useNumber" class="sj">
					<Input v-model="formValidate.useNumber" placeholder="请输入数量" type="number" disabled ></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					id:'',
					redeemCode:'',
					remark:'',
					receiveBeginTime:'',
					beginTime:'',
					overTime:'',
					minMoney:'',
					reduceMoney:'',
					isUse:'true',
					couponType:'MJQ',
					typeId:0,
					commId:0,
					maxNumber:'',
					method:'sm',
					scope:''
				},
				ruleValidate: {
					redeemCode: [{
						required: true,
						message: '兑换码不能为空！！！',
						trigger: 'blur'
					}],
					method: [{
						required: true,
						message: '领取方式不能为空！！！',
						trigger: 'blur'
					}],
					remark: [{
						required: true,
						message: '备注不能为空！！！',
						trigger: 'blur'
					}],
					
					scope: [{
						required: true,
						message: '使用范围不能为空！！！',
						trigger: 'blur'
					}],
					minMoney: [{
						required: true,
						message: '最低金额为空！！！',
						trigger: 'blur'
					}],
					reduceMoney: [{
						required: true,
						message: '满减金额不能为空！！！',
						trigger: 'blur'
					}],
					isUse: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}],
					couponType: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}],
					maxNumber: [{
						required: true,
						message: '数量不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						if(_this.formValidate.receiveBeginTime=="" || _this.formValidate.receiveBeginTime==""){
							_this.$Message.error('请选择开始领取时间!');
							return ;
						}
						if(_this.formValidate.overTime=="" ){
							_this.$Message.error('请选择开始时间!');
							return ;
						}
						if(_this.formValidate.beginTime==""){
							_this.$Message.error('请选择结束时间!');
							return ;
						}
						if(Number(this.formValidate.reduceMoney)>=Number(this.formValidate.minMoney)){
							_this.$Message.error('满减金额必须小于最小金额!');
							return ;
						}
						if(this.formValidate.maxNumber<=0){
							_this.$Message.error('数量必须大于0!');
							return ;
						}
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/coupon/update',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		created() {
			let id=this.$route.query.id
			this.formValidate.id=id
			let _this=this
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/coupon/byId',
			    data: {id:id},
				_this: _this,
				success: function(data) {
					_this.formValidate=data.coupon
					_this.formValidate.isUse+=""
					_this.formValidate.minMoney=_this.formValidate.minMoney/100+""
					_this.formValidate.reduceMoney=_this.formValidate.reduceMoney/100+""
					_this.formValidate.maxNumber+=""
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/coupon/update.vue